import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { BsFillPersonCheckFill, BsFillBookmarkCheckFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { StudyMessageService } from "../model/message-service";
import { encode } from "js-base64";
import { useDispatch, useSelector } from "react-redux";
import { ClearOldSession, EnumMessageType } from "../core/Helper";
import { setReminder } from "../features/UserActions";
import StudyHistory from "./admin/report-study-history";
import StudyHistoryTracking from "./admin/report-study-history";

export default function Home() {
  const userDetail = useSelector((state) => state.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const trackDefault = () => ({ show: false, data: null, action: () => {} });
  const [studyTracking, setStudyTracking] = useState(trackDefault);
  const [trackingWin, setTrackingWin] = useState(<></>);

  useEffect(() => {
    checkOpenStudyFromSession();
    return () => {
      //console.log("RETURNING");
      setTrackingWin(null);
      setStudyTracking(trackDefault);
    };
  }, []);

  const checkOpenStudyFromSession = async () => {
    let pacsStudyId = sessionStorage.getItem("radconn_pacs_study_id");
    let radStaffId = sessionStorage.getItem("radconn_staff_id");
    let paramType = sessionStorage.getItem("radconn_param_type");
    let messageId = sessionStorage.getItem("message_id");

    if (messageId) {
      let ret = await StudyMessageService.CheckRadioValidMessage({
        MessageId: messageId,
        UserInfo: encode(JSON.stringify(userDetail)),
      });
      if (!ret.messageValid) {
        dispatch(
          setReminder({
            show: true,
            message: (
              <div style={{ color: "#f02906" }}>
                <div>ข้อความนี้ไม่มีผลใช้งานแล้ว</div>
                <div>กรุณาติดต่อแอดมิน</div>
                <div>จึงเรียนขออภัยมา ณ ที่นี้</div>
                <div>{ret?.studyInfo?.Radiologist?.FullFirstName}</div>
              </div>
            ),
            type: "error",
          })
        );
      }

      ClearOldSession();
      return;
    }

    if (paramType === "admin_verify_case") {
      setStudyTracking({
        show: true,
        data: { PacsStudyId: pacsStudyId },
        action: (e) => {
          ClearOldSession();
        },
      });
    }
  };

  useEffect(() => {
    setTrackingWin(
      <StudyHistoryTracking
        {...{ winState: [studyTracking, setStudyTracking] }}
      />
    );
  }, [studyTracking]);

  // const menus = useSelector((state)=>state.user.userMenus);
  return <div>{trackingWin}</div>;
}

// =======================================
